import { Route, Routes } from 'react-router-dom';

import { AppShell } from './components/AppShell';
import { ReviewerGate } from './components/ReviewerGate';
import { NotFound } from './pages/NotFound';
import { ReviewerDashboard } from './pages/ReviewerDashboard';
import { RunDetailPage } from './pages/RunDetailPage';
import { UploadPage } from './pages/UploadPage';

/**
 * Route tree.
 *
 *   /                         upload landing
 *   /runs/:runId/*            run detail with nested FIA/schema/manifest/HITL tabs
 *   /*                        404
 *
 * The nested `*` is the critical bit — `RunDetailPage` owns its own
 * sub-router so tab URLs are bookmarkable.
 *
 * ReviewerGate wraps the whole tree so an unauthenticated reviewer sees
 * only the password prompt — no chrome, no data, nothing to scrape. It
 * no-ops when ``VITE_REVIEWER_PASSWORD`` is unset (dev builds).
 */
export default function App() {
  return (
    <ReviewerGate>
      <AppShell>
        <Routes>
          <Route path="/" element={<UploadPage />} />
          <Route path="/runs/:runId/*" element={<RunDetailPage />} />
          <Route path="/hitl" element={<ReviewerDashboard />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AppShell>
    </ReviewerGate>
  );
}
